<template>
    <div>
        <b-card>
            <div class="d-flex justify-content-between">
                <b-card-title>Encaminhamentos</b-card-title>
                <b-button size="xs" variant="default" @click="getEncaminhamentos(); show = !show" class="m-1">
                    Ver Encaminhamentos
                </b-button>
            </div>
            <div v-if="show" class="mt-3">
                <div class="row">
                    <form-select v-model="filtros" label="Filtrar" grid="12" :itens="[
                        {
                            id: 'cadastrados_por_mim',
                            value: 'Cadastrados por mim',
                        },
                        {
                            id: 'enviados_para_mim',
                            value: 'Enviados para mim',
                        },
                        {
                            id: 'minha_unidade_sem_user_detino',
                            value: 'Enviados para minha unidade sem técnico destinatário',
                        },
                        {
                            id: 'todos_enviados_minha_unidade',
                            value: 'Todo enviados para minha Unidade',
                        },
                    ]" @input="getEncaminhamentos()" />
                </div>
                <loading-animation :active.sync="loadingEncaminhamentos" :is-full-page="false" :opacity="1"
                    color="#5895ff" />
                <b-table :fields="[
                    {
                        key: 'protocolo',
                        label: $t('Detalhes'),
                    },
                    {
                        key: 'cadastrado',
                        label: $t('Data'),
                    },
                    {
                        key: 'status_nome',
                        label: $t('Status'),
                    },
                    {
                        key: 'actions',
                        label: '',
                        class: 'text-right',
                        thStyle: { width: '95px', minWidth: '95px' },
                    },
                ]" :items="EncaminhamentosList" :responsive="true" striped hover show-empty small outlined stacked="md"
                    table-class="mb-3">
                    <template v-slot:cell(protocolo)="data">
                        <span class="small">
                            <i class="mdi mdi-lock mdi-18px text-danger" v-if="data.item.privado == 1"></i>
                            <ul v-if="data.item.pessoas_objetos.length > 0">
                                <li v-for="pessoa in data.item.pessoas_objetos" :key="pessoa.id">
                                    <b>{{ pessoa.nome_completo }}</b>
                                    <b-link :to="
                                        '/dashboard/usuario/edit/' +
                                        pessoa.id
                                    " target="_blank">
                                        <i class="fas fa-external-link-alt"></i>
                                    </b-link>
                                </li>
                            </ul>
                            Tipo: <b>{{ data.item.tipo }}</b>
                            <br />
                            Técnico
                            <b>{{ data.item.responsavel.nome }}</b>
                            <br />
                            Destino:
                            <b v-if="data.item.unidade_destino">{{
                                data.item.unidade_destino.nome
                            }}</b>
                            <br />
                            <span v-if="data.item.destino">
                                Destinatário
                                <b>{{ data.item.destino.nome }}</b>
                            </span>
                        </span>
                    </template>
                    <template v-slot:cell(cadastrado)="data">
                        {{ data.item.cadastrado }}
                    </template>
                    <template v-slot:cell(status_nome)="data">
                        <span class="small" v-html="data.item.status_nome"></span>
                    </template>
                    <template v-slot:cell()="data">
                        <button v-if="user_id == data.item.user_id" @click="
                            redirectEncaminhamento(
                                data.item.id,
                                data.item.familia
                            )
                        " class="px-2 mb-0 btn btn-sm btn-success">
                            <i class="mdi mdi-square-edit-outline" />
                        </button>
                        <b-button :title="$t('Visualizar e Imprimir')" :to="
                            '/dashboard/encaminhamentos/show/' +
                            data.item.id
                        " class="px-2 mb-0" size="xs" type="button" v-b-tooltip.hover variant="primary" v-else>
                            <i class="mdi mdi-eye" />
                        </b-button>
                    </template>
                    <template v-slot:empty="scope">
                        <div class="text-center my-5">
                            <img :alt="$t('No results')" class="mb-5" src="/img/icons/robot.svg"
                                style="max-height: 165px" />
                            <h3 class="bold">{{ $t("No records found") }}</h3>
                        </div>
                    </template>
                </b-table>

                <b-pagination v-if="pagination.total > perPage" :per-page="perPage" :total-rows="pagination.total"
                    @change="changePage" v-model="page" align="right" pills />

                <div class="row">
                    <div class="col-md-12">
                        Não localizou os encaminhamentos desejados? Tente
                        acessar a página de
                        <b-link href="/dashboard/relatorios/encaminhamentos/home">relatórios de encaminhamentos</b-link>
                        e realize uma busca avançada.
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            TipoEncaminhamentosList: [],
            EncaminhamentosList: [],
            show: false,
            page: 1,
            search: "",
            perPage: 5,
            loadingEncaminhamentos: true,
            loading: true,
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0,
            },
            user_id: null,
            filtros: "cadastrados_por_mim",
        };
    },
    mounted() {
        // this.getEncaminhamentos();
    },
    methods: {
        getEncaminhamentos() {
            this.loadingEncaminhamentos = true;
            axios
                .get("api/analytics/encaminhamentos/report", {
                    params: {
                        page: this.page,
                        search: this.search,
                        perPage: this.perPage,
                        filtros: this.filtros,
                    },
                })
                .then((response) => {
                    this.user_id = this.$store.state.user.id;
                    this.EncaminhamentosList = response.data.data;
                    this.pagination = response.data.pagination;

                    if (
                        this.pagination.totalPages < this.pagination.currentPage
                    ) {
                        this.page = this.pagination.totalPages;
                        this.getEncaminhamentos();
                    } else {
                        this.loadingEncaminhamentos = false;
                    }
                })
                .catch(() => {
                    this.loadingEncaminhamentos = false;
                });
        },
        changePage(page) {
            if (
                page > 0 &&
                page <= this.pagination.totalPages &&
                page !== this.page
            ) {
                this.page = page;
                this.getEncaminhamentos();
            }
        },
        redirectEncaminhamento(id, familia_id) {
            this.$router.push({
                path: `/dashboard/encaminhamentos/edit/${id}`,
                query: { familia_id: familia_id },
            });
        },
    },
};
</script>

<style></style>
